interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: "left" | "center";
  dark?: boolean;
  className?: string;
}

/**
 * Cabeçalho padrão de seção com eyebrow, título e subtítulo.
 */
export default function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = "center",
  dark = false,
  className = "",
}: SectionHeadingProps) {
  const alignClass =
    align === "center" ? "items-center text-center" : "items-start text-left";

  return (
    <div className={`flex flex-col ${alignClass} ${className}`}>
      {eyebrow && (
        <span
          className={`mb-4 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] ${
            dark ? "text-accent-500" : "text-primary-600"
          }`}
        >
          <span className="h-px w-6 bg-current" />
          {eyebrow}
          {align === "center" && <span className="h-px w-6 bg-current" />}
        </span>
      )}
      <h2
        className={`max-w-3xl font-heading text-3xl font-bold leading-[1.1] tracking-tight md:text-5xl ${
          dark ? "text-foreground-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {subtitle && (
        <p
          className={`mt-5 max-w-2xl text-base leading-relaxed md:text-lg ${
            dark ? "text-foreground-300" : "text-foreground-600"
          }`}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}